export const PopupControlIntervention = () => {
  return <div data-testid="popup-control-intervention"></div>;
};
